const DEBUG = vars.debug;
const postcodeEndpoint = vars.postcodesEndpoint;
const accessToken = vars.accessToken;

mapboxgl.accessToken = accessToken;

const defaultCenter = [-2.3337012937843156, 54.2270598571578]; // Default coordinates [longitude, latitude]
const defaultZoom = 5; // Default zoom level

// Initialize the map
const map = new mapboxgl.Map({
	container: 'map',
	style: 'mapbox://styles/mapbox/light-v10?optimize=true', // Load an empty style initially
	center: defaultCenter, // Center on London
	zoom: defaultZoom,
	maxZoom: 9,
 	minZoom: 5,		
	fadeDuration: 0
});

// Store the ID of the currently highlighted feature
let highlightedFeatureId = null; 

// When the map is loaded, fetch the GeoJSON and add it as a source/layer
map.on('load', function () {

	/** 
	 * Geocoder 
	 */

	map.geocoder = new MapboxGeocoder({
		accessToken: mapboxgl.accessToken,
		types: 'region,place,postcode,locality,neighborhood',
		countries: 'gb',
		placeholder: 'Enter location or postcode',
		limit: 3
	});

	map.scrollZoom.disable(); // Disable scroll zoom

	// if #geocoder element exists, add the geocoder to it
	if (document.getElementById('geocoder')) {
		map.geocoder.addTo('#geocoder');
	}

	// UK Mask
	// =======

	// Add a GeoJSON source with the mask polygon
	map.addSource('uk-mask', {
		'type': 'geojson',
		'data': {
			'type': 'FeatureCollection',
			'features': [
				{
					'type': 'Feature',
					'geometry': {
						'type': 'Polygon',
						'coordinates': [
							// Large polygon that covers the whole map with a hole for the UK boundary
							[
								[-180, -90], [180, -90], [180, 90], [-180, 90], [-180, -90] // Outer boundary
							],
							[
								[-10.816389731616312, 53.76957525142828],
								[-7.608281270684245, 58.543988721602176],
								[-0.7202836928002228, 61.16442097887992],
								[-0.05979077437285696, 60.936060224364724],
								[-1.91546135471566, 58.13125473885438],
								[-0.5315714303919776, 57.426951852420785],
								[2.393468636928475, 52.448068636680205],
								[1.8273318497052173, 51.16464952702091],
								[0.3628721154310597, 50.59338760251643],
								[-5.4513395448543065, 49.80275666831241],
								[-10.722033600412203, 51.361458961995424],
								[-10.81633608651569, 53.76931145528977]
							]
						]
					},
					'properties': {}
				}
			]
		}
	});

	// Add the vector tileset as a source for the UK mask
	// map.addSource('uk-mask', {
	// 	'type': 'vector',
	// 	'url': 'mapbox://jaskcreative.bo9zv87l'  // Replace with your tileset ID
	// });

	// Add the fill layer for the mask
	map.addLayer({
		'id': 'uk-mask-layer',
		'type': 'fill',
		'source': 'uk-mask',
		// 'source-layer': 'ukmask',
		'layout': {},
		'paint': {
			'fill-color': '#C9D1D2', // The color to "mask out" other countries
			'fill-opacity': 1 // Adjust transparency
		}
	});

	// Postcodes / Counties
	// ====================

	// Add the filtered GeoJSON as a source to the map
	map.addSource('postcode-boundaries', {
		type: 'geojson',
		data: postcodeEndpoint
	});

	// Add the vector tileset as a source instead of GeoJSON
	// map.addSource('postcode-boundaries', {
	// 	'type': 'vector',
	// 	'url': 'mapbox://jaskcreative.1y1hi9j7'  // Replace with your tileset ID
	// });

	// Add a layer to visualize the postcode areas
	map.addLayer({
		'id': 'postcode-boundaries-layer',
		'type': 'fill',
		'source': 'postcode-boundaries',
		// 'source-layer': 'fulltactboundaries',
		'layout': {},
		'paint': {
			'fill-color': ["get", "fill"],
			'fill-opacity': [
				'case',
				['boolean', ['feature-state', 'highlighted'], false],
				0.82, // Highlighted opacity
				["get", "fill-opacity"], // Default opacity
			],
		}
	});

	// Add a boundary line
	map.addLayer({
		'id': 'postcode-boundaries-outline',
		'type': 'line',
		'source': 'postcode-boundaries',
		// 'source-layer': 'fulltactboundaries',
		'layout': {},
		'paint': {
			'line-color': ["get", "stroke"],
			'line-width': ["get", "stroke-width"],
			'line-opacity': ["get", "stroke-opacity"]
		}
	});

	// Add zoom controls
	map.addControl(new mapboxgl.NavigationControl());

	// Change the cursor to a pointer when the mouse is over the postcode-boundaries-layer.
	map.on('mouseenter', 'postcode-boundaries-layer', function() {
		map.getCanvas().style.cursor = 'pointer';
	});

	// Change it back to a pointer when it leaves.
	map.on('mouseleave', 'postcode-boundaries-layer', function() {
		map.getCanvas().style.cursor = '';
	});

	// Process the geocoder result
	map.geocoder.on('result', (event) => {

		document.getElementById('clear-button').style.display = 'block'; // Show the clear button

		// Reset map zoom level
		map.flyTo({
			center: defaultCenter,
			zoom: defaultZoom,
			essential: true,
		});

		map.once('moveend', function(){
			// Remove any existing marker if you only want one marker at a time
			if (window.currentMarker) {
				window.currentMarker.remove();
			}
		
			// Get the coordinates from the result
			const coordinates = event.result.geometry.coordinates;
		
			// Create a new marker and set its position to the coordinates
			window.currentMarker = new mapboxgl.Marker()
				.setLngLat(coordinates)
				.addTo(map);

			/**
			 * Check if the marker is within a polygon
			 */

			// Convert to map pixel point
			const point = map.project(coordinates);
		
			// Query rendered features (polygons) at this point
			const features = map.queryRenderedFeatures(point, {
				layers: ['postcode-boundaries-layer'],
			});

			// Reset the previously highlighted feature
			if (highlightedFeatureId !== null) {
				map.setFeatureState(
					{ source: 'postcode-boundaries', id: highlightedFeatureId },
					{ highlighted: false }
				);
			}
		
			// Check if any polygon contains the point
			if (features.length > 0) {
				console.log('The point is within a polygon:', features[0]);

				// Convert the array of features into a GeoJSON FeatureCollection
				const featureCollection = {
					type: 'FeatureCollection',
					features: features
				};

				// Use turf.bbox to calculate the bounding box
				const bbox = turf.bbox(featureCollection);

				// Optionally, fit the map to the bounding box
				map.fitBounds(bbox, { padding: 15 });

				// Output the properties to a HTML element on the page
				const properties = features[0].properties;
				const description = `<div class="postcode-results__item">
					<h4 class="wp-block-heading">` + properties.area_team + `</h4>
					<p>Our team in ` + properties.area_team + ` can help you with your enquiry.</p>
					<div class="postcode-results__item__bottom">
						<div class="wp-block-button">
							<a href="` + properties.location_url + `" class="wp-block-button__link">Find out more</a>
						</div>
					</div>
				</div>`;
				document.getElementById('postcode-results').innerHTML = description;

				// Highlight the new feature
				highlightedFeatureId = features[0].properties.property_id; // Update the highlighted feature ID
		
				map.setFeatureState(
					{ source: 'postcode-boundaries', id: features[0].properties.property_id },
					{ highlighted: true }
				);

			} else {

				// Output the message of dissapointment
				const description = `<div class="postcode-results__item">
					<p>Sorry, we don't currently offer coverage in your area</p>
				</div>`;
				document.getElementById('postcode-results').innerHTML = description;

				console.log('The point is not within any polygon.');
			}
		
		});

	});
	
	// Clear results container when search is cleared.
	map.geocoder.on('clear', function () {

		document.getElementById('clear-button').style.display = 'none'; // Hide the clear button

		// Clear the results container
		document.getElementById('postcode-results').innerHTML = "";

		// Reset the previously highlighted feature
		if (highlightedFeatureId !== null) {
			map.setFeatureState(
				{ source: 'postcode-boundaries', id: highlightedFeatureId },
				{ highlighted: false }
			);
		}

		// Remove the marker
		window.currentMarker.remove();
		
		// Reset the map
		map.flyTo({
			center: defaultCenter,
			zoom: defaultZoom,
			essential: true,
		});

	});

	map.on('click', 'postcode-boundaries-layer', function (e) {
		let description = ''
		let team_name = e.features[0].properties.area_team ?? ''
		let location_url = e.features[0].properties.location_url ?? ''

		description = `<h6>` + team_name + `</h6><p><a href="` + location_url + `">Find out more</a></p>`;

		// Reset the previously highlighted feature
		if (highlightedFeatureId !== null) {
			map.setFeatureState(
				{ source: 'postcode-boundaries', id: highlightedFeatureId },
				{ highlighted: false }
			);
		}

		// Highlight the new feature
		highlightedFeatureId = e.features[0].properties.property_id; // Update the highlighted feature ID

		map.setFeatureState(
			{ source: 'postcode-boundaries', id: e.features[0].properties.property_id },
			{ highlighted: true }
		);

		const popup = new mapboxgl.Popup()
			.setLngLat(e.lngLat)
			.setHTML(description)
			.addTo(map);

		popup.on('close', () => {
			// Reset the previously highlighted feature
			if (highlightedFeatureId !== null) {
				map.setFeatureState(
					{ source: 'postcode-boundaries', id: highlightedFeatureId },
					{ highlighted: false }
				);
			}
		});
	});
});

// Check to see if we are on a location page and zoom into that area, we must wait for the map to load fully before doing this.
// It may be more efficent to use PHP and have a different endpoint for this, however, with the caching it should be fine as the main endpoint has more chance of existing in the cache than the location one would have.
map.once('idle', (e) => {
	if (document.getElementById('map').hasAttribute('data-location-id')) {
		// Query the rendered features
		const features = map.queryRenderedFeatures({
			layers: ['postcode-boundaries-layer'],
		});

		// Check if there are any features
		if (features.length > 0) {
			// Convert the array of features into a GeoJSON FeatureCollection
			const featureCollection = {
				type: 'FeatureCollection',
				features: features
			};

			// Use turf.bbox to calculate the bounding box
			const bbox = turf.bbox(featureCollection);

			// Optionally, fit the map to the bounding box
			map.fitBounds(bbox, { padding: 15 });
		} else {
			console.log('No features found');
		}
	}
});

// Add clear button to the geocoder
document.getElementById('clear-button').addEventListener('click', () => {
	map.geocoder.clear(); // Clears the geocoder input and results
});